import React from 'react'
import {
  Filter, SelectInput, TextInput, DateInput, BooleanInput
} from 'react-admin'
import useTestTypesList from '../../utils/useTestTypesList'
import useCompetencesList from '../../utils/useCompetencesList'
import useCriteriasList from '../../utils/useCriteriasList'
import useModulesList from '../../utils/useModulesList'
import useVerifyStatusesList from '../../utils/useVerifyStatusesList'
import useProgramsNumbersList from '../../utils/useProgramsNumbersList'
import useProgramsList from '../../utils/useProgramsList'
import useTopicsList from '../../utils/useTopicsList'
import useDifficultLevelsList from '../../utils/useDifficultLevelsList'

const SegmentsListFilters = ({
  statusId,
  levelTypes,
  ...props
}) => {
  const { filterValues } = props

  let programId = filterValues.programId
  let moduleId = filterValues.moduleId
  let topicId = filterValues.topicId

  const types = useTestTypesList()
  const competences = useCompetencesList()
  const criterias = useCriteriasList()
  const modules = useModulesList()
  const verifyStatuses = useVerifyStatusesList()
  const progamNumber = useProgramsNumbersList()
  const progamNumberFrom = useProgramsList()
  const topicsList = useTopicsList()
  const difficultLevels = useDifficultLevelsList()

  /**
   * Возвращает список вопросов для фильтра.
   * Если заполнена тема, то фильтруем по ней, если нет, то по модулю.
   */
  const getProgramNumbers = () => {
      if (topicId) {
          return progamNumber.filter(progamNumber => progamNumber.topicId === topicId)
      }

      const filteredPrograms = progamNumberFrom.filter(item => item.moduleId === moduleId).map(item => item.id)
      const filteredTopics = topicsList.filter(item => filteredPrograms.indexOf(item.programId) !== -1).map(item => item.id)
      return progamNumber.filter(item => filteredTopics.indexOf(item.topicId) !== -1)
  }

  return (
    <Filter {...props}>
      <TextInput
        label="ID сегмента"
        source="id"
        allowEmpty={false}
      />
      <TextInput
        label="Текст сегмента"
        source="text"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="Уровень экзамена"
        choices={levelTypes}
        source="levelType"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="Модуль"
        choices={modules}
        source="moduleId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="Вид сегмента"
        choices={types}
        source="typeId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="Тип теста"
        choices={criterias}
        source="criteriaId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        title="Выберите модуль"
        label="№ раздела"
        choices={progamNumberFrom.filter(progamNumberFrom => progamNumberFrom.moduleId === moduleId)}
        disabled={!moduleId}
        source="programId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="№ темы"
        title="Выберите раздел программы"
        disabled={!programId}
        choices={topicsList.filter(topic => topic.programId === programId)}
        source="topicId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="№ вопроса"
        title="Выберите номер темы"
        choices={getProgramNumbers()}
        source="programNumberId"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="№ компетенции"
        title="Выберите раздел программы и раздел программы"
        disabled={!moduleId && !topicId}
        choices={competences.filter(competence => competence.programId === programId && competence.topicId === topicId)}
        source="competence"
        allowEmpty={false}
      />
      <TextInput
        label="№ разработчика"
        source="createdById"
        allowEmpty={false}
      />
      <DateInput
        label="Дата загрузки с"
        source="from" />
      <DateInput
        label="Дата загрузки по"
        source="to" />
      <DateInput
        label="Дата архивации с"
        source="deactivateFrom" />
      <DateInput
        label="Дата архивации по"
        source="deactivateTo" />
      <TextInput
        label="Назначен на"
        source="assignedName"
        allowEmpty={false}
      />
      {statusId !== 1 && (
        <SelectInput
          optionText="name"
          optionValue="id"
          label="Статус проверки"
          choices={verifyStatuses}
          source="verifyStatusId"
          allowEmpty={false}
        />
      )}
      <BooleanInput
        label="IT-сегмент"
        source="isIt"
      />
      <TextInput
        label="Комментарий"
        source="comment"
        allowEmpty={false}
      />
      <SelectInput
        optionText="name"
        optionValue="id"
        label="Уровень сложности"
        choices={difficultLevels}
        source="difficultLevel"
        allowEmpty={false}
      />
    </Filter>
  )
}

export default SegmentsListFilters
